<template>
  <div class="ml-3">
    <v-row
      v-for="(mapping, index) of value"
      :key="index"
      class="my-2 och-epicMappingRow"
    >
      <v-col cols="2">
        <v-text-field
          clearable
          label="Epic Item Number"
          type="number"
          v-model.number="mapping.epicItemNumber"
          :rules="[
            v => !!v || 'Epic Item Number is required',
            v => v !== 1 || 'Item number 1 is set by Epic ID Type',
          ]"
        ></v-text-field>
      </v-col>
      <v-col cols="2">
        <v-select
          @change="onMappingValueTypeChange(index)"
          :items="valueTypeOptionList"
          item-text="label"
          item-value="id"
          label="Value Type"
          v-model="mapping.valueType"
        ></v-select
      ></v-col>
      <v-col>
        <div v-if="mapping.valueType === 'attribute'">
          <v-autocomplete
            @change="onMappingAttributeValueChange(index)"
            :items="entityAttributeList"
            :rules="[v => !!v || 'Required']"
            clearable
            item-text="label"
            item-value="name"
            label="Attribute"
            v-model="mapping.value"
          ></v-autocomplete>
          <v-autocomplete
            :items="getAssociatedAttributeNameList(mapping.value)"
            :rules="[v => !!v || 'Required']"
            clearable
            item-text="label"
            item-value="name"
            label="Associated Attribute"
            v-if="showAssociatedAttributeNameList(mapping.value)"
            v-model="mapping.fkValue"
          ></v-autocomplete>
        </div>
        <v-textarea
          :rules="[v => !!v || 'Required']"
          clearable
          label="Computed Value"
          v-else-if="mapping.valueType === 'computed'"
          v-model="mapping.value"
        ></v-textarea>
        <v-textarea
          :auto-grow="true"
          :rows="1"
          :rules="[v => !!v || 'Required']"
          clearable
          label="Static Value"
          v-else
          v-model="mapping.value"
        ></v-textarea
      ></v-col>
      <v-col cols="1" align-self="center">
        <v-btn @click="value.splice(index, 1)" color="primary" outlined x-small
          >Remove</v-btn
        >
      </v-col>
    </v-row>
    <v-btn
      @click="
        value
          ? value.push({ valueType: valueTypeOptionList[0].id })
          : (value = [{ valueType: valueTypeOptionList[0].id }])
      "
      class="mt-2"
      color="primary"
      outlined
      small
      >Add</v-btn
    >
  </div>
</template>

<script>
import { get } from "lodash";
import { mapGetters } from "vuex";

import formElementMixin from "./formElementMixin";

export default {
  computed: {
    entityAttributeList() {
      const { optionAttributeEntityName } = this;

      let entityAttributeList = get(
        this.$store.state,
        `${optionAttributeEntityName}.list`
      ).concat(
        this.$store.getters[`attribute/filter`]({
          entityName: this.parentEntityName,
        })
      );

      entityAttributeList = entityAttributeList.filter(
        item => item.name !== "crowdKey"
      );

      return entityAttributeList.sort((a, b) => {
        return a.label < b.label ? -1 : 1;
      });
    },
    ...mapGetters({
      filterAttribute: "attribute/filter",
    }),
  },
  async created() {
    const { optionAttributeEntityName } = this;

    this.loading = true;
    await Promise.all([
      this.entityGetList({
        entityName: "attribute",
        optionMap: { reload: true },
      }),
      this.entityGetList({
        entityName: optionAttributeEntityName,
        optionMap: { reload: false },
      }),
    ]);
    this.loading = false;
  },
  data() {
    return {
      loading: false,
      valueTypeOptionList: [
        {
          id: "attribute",
          label: "Attribute",
        },
        {
          id: "static",
          label: "Static",
        },
        {
          id: "computed",
          label: "Computed",
        },
      ],
    };
  },
  methods: {
    async entityGetList({ entityName, optionMap }) {
      return this.$store.dispatch(`${entityName}/list`, optionMap);
    },
    getAssociatedAttributeNameList(entityAttributeName) {
      const entityAttribute = this.getEntityAttribute(entityAttributeName);

      const { fkExists, fkName } = entityAttribute;

      if (!fkExists || !fkName) {
        return [];
      }

      const attributeList = this.filterAttribute({ entityName: fkName });

      return attributeList.sort((a, b) => {
        return a.label < b.label ? -1 : 1;
      });
    },
    getEntityAttribute(entityAttributeName) {
      const { entityAttributeList } = this;

      const entityAttribute = entityAttributeList.find(
        attribute => attribute.name === entityAttributeName
      );

      return entityAttribute;
    },
    onMappingAttributeValueChange(index) {
      this.$set(this.value[index], "fkValue", null);
    },
    onMappingValueTypeChange(index) {
      this.$set(this.value[index], "fkValue", null);
      this.$set(this.value[index], "value", null);
    },
    showAssociatedAttributeNameList(entityAttributeName) {
      if (!entityAttributeName) {
        return false;
      }

      const entityAttribute = this.getEntityAttribute(entityAttributeName);

      if (!entityAttribute) {
        return false;
      }

      const { fkExists, fkName, fkType } = entityAttribute;

      if (!fkExists || !fkName) {
        return false;
      }

      // Don't show options for options, just fk table references
      if (fkType) {
        return false;
      }

      return true;
    },
  },
  mixins: [formElementMixin],
  props: {
    optionAttributeEntityName: {
      // Name of attribute type, ex. "userAttribute" or "resourceAttribute".
      required: true,
      type: String,
    },
    parentEntityName: {
      // Name of entity referenced by attribute, ex. "user" or "resource".
      required: true,
      type: String,
    },
  },
};
</script>
<style>
.och-epicMappingRow {
  border: 1px solid gray;
  border-radius: 5px;
}
</style>
